import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type PopupContent from './popup-content';

export const errorPopupEntryPoint: EntryPoint<typeof PopupContent, {}> = createEntryPoint({
	root: JSResourceForInteraction<typeof PopupContent>(
		() =>
			new Promise<typeof PopupContent>((_, reject) => {
				// Deliberately fail after a short loading state; never load real content.
				setTimeout(() => reject(new Error('Intentional popup documentation error')), 800);
			}),
		{ moduleId: 'constellation-error-popup-entry-point' },
	),
	getPreloadProps: () => ({}),
});
